var basic = require('./basic');
var verification = require('./verification');

// TODO: Add common validation messages
module.exports = {
    validateName: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validateName(value) ? resolve() : reject();
        // });
        return $.when(basic.validateName(value));
    },
    validateEmail: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validateEmail(value) ? resolve() : reject();
        // });
        return $.when(basic.validateEmail(value));
    },
    validatePhoneNumber: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validatePhoneNumber(value) ? resolve() : reject();
        // });
        return $.when(basic.validatePhoneNumber(value));
    },
    validateZipCode: function(value) {
        return $.when(basic.validateZipCode(value));
    },
    verifyEmail: function(value) {
        // return new Promise(function(resolve, reject) {
        //     verification.verifyEmail(value).then(function(data) {
        //         data.isValid ? resolve() : reject();
        //     }, reject);
        // });
        return verification.verifyEmail(value);
    },
    verifyPhoneNumber: function(value) {
        // return new Promise(function(resolve, reject) {
        //     verification.verifyPhoneNumber(value).then(function(data) {
        //         data.isValid ? resolve() : reject();
        //     }, reject);
        // });
        return verification.verifyPhoneNumber(value);
    },
    verifyZipCode: function(value) {
        return verification.verifyZipCode(value);
    },

    validateMinLength: function(value, minLength) {
        return $.when(basic.validateMinLength(value, minLength));
    },
    shouldMatch: function(value, skip, shouldMatchValue ) {
        return $.when( value == shouldMatchValue );
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/common/index.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 19 21 24 25